export default __webpack_public_path__ + "static/media/wb-14.d6990225.webp";